import { useMemo } from 'react';
import ReactModal from 'react-modal';
import iconCloseModal from '../../icons/close-modal.svg';
import '../../styles/modal.scss';

const Modal = (props) =>
  useMemo(() => (
    <ReactModal className={`modal ${props?.extraClass && props.extraClass}`} overlayClassName='backdrop' {...props}>
      <div className='scroll-frame'>
        <div className='scroll-container'>{props.children}</div>
      </div>
      <div className='close-icon-container'>
        <span className='close' onClick={props.onRequestClose}>
          <img src={iconCloseModal} alt='' />
        </span>
      </div>
    </ReactModal>
  ));

export default Modal;
